import { render } from "./InterfaceUpdateSnackbar.vue?vue&type=template&id=afbeeb64&scoped=true"
import script from "./InterfaceUpdateSnackbar.vue?vue&type=script&lang=js"
export * from "./InterfaceUpdateSnackbar.vue?vue&type=script&lang=js"

import "./InterfaceUpdateSnackbar.vue?vue&type=style&index=0&id=afbeeb64&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbeeb64"]])

export default __exports__